import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RateIndexLookupModel } from 'app/generated/backend/trade/api/rate-index-lookup-model';

@Injectable()
export class RateIndexLookupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<RateIndexLookupModel[]>> {
		return this.http.get<JsonResourceResponse<RateIndexLookupModel[]>>('api/v1/trade/rateIndexes/lookup').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		RateIndexLookupHandlerService
	]
})
export class RateIndexLookupHandlerModule { }
